/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
import {
  setBodyEvents,
  setEvents,
  setMixEvents,
  setConfirmData,
} from "../../common/actions/common.actions";
import refreshIcon from "../../../assets/newIcons/rotate-right.png";
import shoeIcon from "../../../assets/newIcons/sports-video-intersound.png";
import football from "../../../assets/newIcons/football2.png";
import HistoryIco from "../../../assets/newIcons/time-machine.png";
import Soccer from "../../../assets/newIcons/scoreboard.png"
import Credit from "../../../assets/newIcons/credit.png";
import onGoing from "../../../assets/newIcons/play.png";
import dashboardService from "../../../api/services/dashboardService";
import withAuth from "../../common/hoc/withAuth";
import SideBarToggle from "../../common/components/sidebar/SideBarToggle";
import Logo from "../../common/components/Logo";
import PopupModal from "./popupModal";
import { useTranslation } from "react-i18next";
import { selectLoginData } from "../login/login.actions";
import signalRConnection from "../../../signalR/signalRService";

const TABS = [
  { labelKey: "maungg", icon: shoeIcon, path: "/maungg" },
  { labelKey: "body", icon: football, path: "/body" },
  { labelKey: "matches", icon: onGoing, path: "/selected-matches" },
  { labelKey: "oldHistories", icon: HistoryIco, path: "/old-histories" },
  { labelKey: "transaction", icon: Credit, path: "/transactions" },
  { labelKey: "result", icon: Soccer, path: "/goal-score" },
];

function Dashboard({ setShowSideBar, setIsLoading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [displayTextArr, setDisplayTextArr] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { userDetails } = useSelector(selectLoginData);
  const [userBalance, setUserBalance] = useState(userDetails?.balance);
  const [refresh, setRefresh] = useState(false);

  const userType = userDetails?.userType;
  const isCreditUser =
    typeof userType === "string" &&
    userType.trim().toLowerCase().includes("credit");
  const dashboardTabs = useMemo(
    () =>
      TABS.filter(
        ({ path }) => !(isCreditUser && path === "/transactions")
      ),
    [isCreditUser]
  );

  useEffect(() => {
    const handleChangedBalance = async () => {
      await updateUserBalance(userDetails);
    };
    signalRConnection.on("changedBalance", handleChangedBalance);
    return () => {
      signalRConnection.off("changedBalance", handleChangedBalance);
    };
  }, [userDetails]);

  useEffect(() => {
    const initData = async () => {
      try {
        dispatch(setConfirmData(null));
        const data = await dashboardService
          .getDisplayTextForDashboard()
          .then((res) => res.json());
        setDisplayTextArr(data);
        await updateUserBalance(userDetails);
      } catch (error) {
        console.error(error);
      }
    };

    initData();
    dispatch(setMixEvents([]));
    dispatch(setBodyEvents([]));
    dispatch(setEvents([]));
    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (storedUserDetails?.balance) setUserBalance(storedUserDetails.balance);
  }, [refresh]);

  const updateUserBalance = async (user) => {
    if (!user?.userId) return;
    try {
      const userId = Number(user.userId);
      const res = await dashboardService
        .getBalanceForDashboard(userId)
        .then((res) => res.json());
      if (res?.userInfo?.length) {
        setUserBalance(res.userInfo[0]?.balance);
        localStorage.setItem("userDetails", JSON.stringify(res.userInfo[0]));
      }
    } catch (error) {
      console.error("Error updating user balance:", error);
    }
  };

  return (
    <div className="flex flex-col  min-h-screen w-full font-myanmarSansPro relative"
        style={{
          backgroundImage: `url(${require('../../../assets/images/home.png')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
      {/* Top App Bar */}
      <header className="flex items-center justify-between px-4 py-3 text-white">
        <div className="flex items-center gap-2">
          <SideBarToggle setShowSideBar={setShowSideBar} />
          {/* <div className="mt-2">
            <Logo />
          </div> */}
        </div>
        <div className="flex items-center gap-2 border-b px-4">
          <button
            onClick={() => {
              setRefresh(true);
              setTimeout(() => setRefresh(false), 1500);
            }}
            className={`w-5 ${refresh ? "animate-spin" : ""}`}
            aria-label="Refresh Balance"
          >
            <img src={refreshIcon} alt="refresh" />
          </button>
          <span className="text-sm font-bold">
            {parseInt(userBalance).toLocaleString()} Ks
          </span>
        </div>
      </header>

      {/* Marquee Announcement */}
      <PopupModal
        data={displayTextArr}
        isPopupOpen={isPopupOpen}
        setIsPopupOpen={setIsPopupOpen}
      />

      <main className="flex flex-col items-center px-4 gap-8 md:w-2/5 w-full mx-auto">
        <div
          className="w-full p-2 border-b border-gray-200 hover:shadow-md cursor-pointer"
          onClick={() => setIsPopupOpen(true)}
        >
          <Marquee className="text-white text-sm font-semibold">
            {displayTextArr.map((d) => d.displayText).join(" ")}
          </Marquee>
        </div>

        {/* Betting image */}
        {/* <img
          src={bettingpng}
          alt="betting"
          className="max-w-full px-2 object-contain overflow-hidden"
        /> */}
        <div className="h-56">

        </div>

        {/* Centered Tab Items - horizontal scroll on mobile, 3 per row on desktop */}
        <nav
          className="w-full flex flex-wrap justify-center gap-4
            overflow-x-auto no-scrollbar
            snap-x snap-mandatory touch-pan-x mt-10
            py-4"
          aria-label="Dashboard navigation"
        >
          {dashboardTabs.map(({ labelKey, icon, path }) => (
            <button
              key={path}
              onClick={() => navigate(path)}
              className="snap-center relative flex flex-col justify-center items-center flex-shrink-0 w-[29%] min-w-[80px] h-[100px] p-3 rounded-lg
              bg-gradient-to-br from-emerald-700 to-emerald-400 border-0 border-gray-400 shadow
              hover:shadow-lg hover:scale-105 group transition-transform duration-200 ease-in-out cursor-pointer"
              aria-label={t(labelKey)}
              type="button"

            >
              <img src={icon} alt={t(labelKey)} className="w-8 h-8 mb-2" />
              <span className="text-xs font-semibold text-gray-800 text-center">
                {t(labelKey)}
              </span>
              <div className="transition-all duration-500 h-[6px] w-1/3 bg-gradient-to-r absolute -bottom-1 group-hover:from-indigo-600 group-hover:to-blue-300 group-active:from-indigo-600 group-active:to-blue-300 from-blue-300 to-indigo-600 rounded-full">

              </div>
            </button>
          ))}
        </nav>
      </main>

      {/* Floating Action Button */}
      {/* <button
        onClick={() => navigate("/maungg")}
        className="fixed bottom-28 right-6 bg-blue-600 text-white text-2xl w-14 h-14 rounded-full shadow-lg hover:bg-blue-700 transition"
        aria-label="Add new"
      >
        +
      </button> */}
    </div>
  );
}

export default withAuth(Dashboard);

/* 
Add this CSS to your global styles or Tailwind config to hide scrollbars:

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;  // IE & Edge
  scrollbar-width: none;     // Firefox
}
.touch-pan-x {
  touch-action: pan-x;
}
*/
